import React, { useCallback, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";

import Container from "@mui/material/Container";

import { notBlank } from "../../util/ext";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import PanelLoadingIndicator from "../../components/PanelLoadingIndicator";
import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Header from "../../creator-application/common/Header";
import { useGetChunkDetail } from "./processingDiscoveryServices";
import Grid from "@mui/material/Grid";
import LabeledReadOnly from "../../components/LabeledReadOnly";
import ReadOnlyField from "../../components/ReadOnlyField";
import ChunkStepsTable from "./ChunkStepsTable";

const useStyles = scrollVisible =>
  makeStyles(theme => ({
    root: {
      border: "3px white solid",
      backgroundColor: "white",
      borderRadius: "20px",
    },

    panel: {
      backgroundColor: "white",
      paddingLeft: theme.spacing(4),
      paddingRight: scrollVisible ? theme.spacing(0) : theme.spacing(4),
    },
  }));

const ContentIngestionChunkDetailView = () => {
  const [scrollVisible, setScrollVisible] = useState(true);
  const classes = useStyles(scrollVisible)();
  const navigate = useNavigate();
  const state = useLocation().state ?? {};
  const { jobId, chunkId } = useParams();

  console.log("####################################################");
  console.log(`job id: ${jobId} -- chunk id: ${chunkId}`);
  console.log("####################################################");

  const {
    data: chunkDetail,
    isLoading: isChunkDetailLoading,
    isSuccess: isChunkDetailSuccess,
  } = useGetChunkDetail(jobId, chunkId);

  const [page, setPage] = useState(0);
  const handlePageChange = useCallback((event, newPage) => {
    setPage(newPage);
  }, []);

  const handleScrollVisible = useCallback(visible => {
    setScrollVisible(visible);
  }, []);

  return (
    <Container id="chunk-detail" classes={{ root: classes.root }}>
      <Header
        title="Chunk Details"
        selectedActions={
          <Box>
            <Button
              variant="text"
              startIcon={<ArrowBackIcon />}
              onClick={() =>
                notBlank(state) && notBlank(state.previousLocation)
                  ? navigate(state.previousLocation)
                  : navigate(`/content-ingestion-report/${jobId}`)
              }
            >
              {notBlank(state) && notBlank(state.label)
                ? state.label
                : "Back to Browse"}
            </Button>
          </Box>
        }
      />
      <Container classes={{ root: classes.panel }}>
        {isChunkDetailLoading && (
          <Container style={{ height: 400 }}>
            <PanelLoadingIndicator />
          </Container>
        )}
        {isChunkDetailSuccess && notBlank(chunkDetail) && (
          <Box m={4}>
            <Grid container spacing={2}>
              <Grid item sm={6}>
                <LabeledReadOnly label="Chunk Id">
                  <ReadOnlyField>{chunkDetail.chunkId}</ReadOnlyField>
                </LabeledReadOnly>
              </Grid>

              <Grid item sm={6}>
                <LabeledReadOnly label="Chunk Status">
                  <ReadOnlyField>{chunkDetail.status}</ReadOnlyField>
                </LabeledReadOnly>
              </Grid>

              {notBlank(chunkDetail.mediaId) && (
                <Grid item sm={6}>
                  <LabeledReadOnly label="Media Id">
                    <ReadOnlyField>{chunkDetail.mediaId}</ReadOnlyField>
                  </LabeledReadOnly>
                </Grid>
              )}

              {notBlank(chunkDetail.mediaType) && (
                <Grid item sm={6}>
                  <LabeledReadOnly label="Media Type">
                    <ReadOnlyField>{chunkDetail.mediaType}</ReadOnlyField>
                  </LabeledReadOnly>
                </Grid>
              )}

              {notBlank(chunkDetail.title) && (
                <Grid item sm={12}>
                  <LabeledReadOnly label="Title">
                    <ReadOnlyField>{chunkDetail.title}</ReadOnlyField>
                  </LabeledReadOnly>
                </Grid>
              )}

              {notBlank(chunkDetail.isbn) && (
                <Grid item sm={12}>
                  <LabeledReadOnly label="ISBN">
                    <ReadOnlyField>{chunkDetail.isbn}</ReadOnlyField>
                  </LabeledReadOnly>
                </Grid>
              )}
            </Grid>
          </Box>
        )}

        {isChunkDetailSuccess && notBlank(chunkDetail.steps) && (
          <ChunkStepsTable
            steps={chunkDetail.steps}
            page={page}
            onPageChange={handlePageChange}
            onScrollVisible={handleScrollVisible}
          />
        )}
      </Container>
    </Container>
  );
};

export default ContentIngestionChunkDetailView;
